import React, { useState, useEffect, useRef } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/HaronicsProfile.css';
import harshit from "../assets/images/harshith11.png"
import OilComparison from './ColdPressed';
import AwardSection from './Award-section';


const HaronicsProfile = () => {
    // Refs for scroll animations
    const [sectionRefs] = useState(() =>
        Array(10).fill(null).map(() => React.createRef())
    );
    // State for animations
    const [visibleSections, setVisibleSections] = useState({});
    const [scrollPosition, setScrollPosition] = useState(0);

    // Handle scroll for parallax and animation effects
    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(window.scrollY);

            // Check which sections are visible
            sectionRefs.forEach((ref, index) => {
                if (ref.current) {
                    const rect = ref.current.getBoundingClientRect();
                    const isVisible = rect.top < window.innerHeight * 0.8 && rect.bottom > 0;

                    setVisibleSections(prev => ({
                        ...prev,
                        [index]: isVisible
                    }));
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial check

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Animation classes based on visibility
    const getAnimationClass = (index) => {
        return visibleSections[index] ? 'animate-in' : '';
    };

    // Parallax effect calculation
    const getParallaxStyle = (factor = 0.2) => {
        return {
            transform: `translateY(${scrollPosition * factor}px)`
        };
    };

    // Toggle for expandable sections
    const [expandedSections, setExpandedSections] = useState({});
    const toggleSection = (index) => {
        setExpandedSections(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    return (
        <div className="haronics-profile">

            {/* Section 3: Our Brand Story */}
            <section
                ref={sectionRefs[2]}
                className={`brand-story-section ${getAnimationClass(2)}`}
                id='fullstory'
            >
                <div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="fade-in">Our Brand Story</h2>
                            <div className="subtitle fade-in delay-1">Born from Tradition. Crafted for Today.</div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-6">
                            <div className="story-content fade-in-left">
                                <p>
                                    The story of Haronics Consumer Products LLP began with a simple idea: to bring India's
                                    time-honored food traditions into the homes of modern consumers—pure, unaltered, and full
                                    of flavor.
                                </p>
                                <p>
                                    Founded in Bengaluru in 2021, Haronics was created by a group of passionate individuals
                                    who grew up with the taste and trust of homemade products—like cold-pressed oils and
                                    coconut delicacies—crafted with care in their family kitchens.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="story-content fade-in-right">
                                <p>
                                    At Haronics, we set out to bridge the gap between heritage and health—by reviving
                                    ancestral preparation methods like wood-pressed oil extraction and slow baking, and using
                                    minimal ingredients without artificial additives or preservatives.
                                </p>
                                <p>
                                    Today, Haronics stands for more than just products—it stands for a movement back to
                                    roots, back to real. We invite you to taste the difference, feel the purity, and be part of our journey.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <div className="brand-quote scale-in">
                                <em>We don't mass-produce. We handcraft.</em>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="floating-elements">
                    <div className="float-item item-1"></div>
                    <div className="float-item item-2"></div>
                    <div className="float-item item-3"></div>
                </div>
            </section>

            {/* Section 4: Founder's Message */}
            <section
                ref={sectionRefs[3]}
                className={`founders-section ${getAnimationClass(3)}`}
            >
                <div>
                    <div className="founder-card">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="founder-image rotate-in">
                                    <div className="image-placeholder">
                                        <div className="founder-avatar">
                                            <img src={harshit} alt="img" />
                                        </div>
                                        <div className="signature text-center">Warm regards, HARSHITH S V <br></br><p>Founder and CEO</p></div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="founder-message fade-in-up">
                                    <h2>Founder's Message</h2>
                                    <p>
                                        Dear Valued Customers,
                                    </p>
                                    <p>
                                        When we started Haronics Cold Pressed Oils, our goal wasn't just to build a brand—it was
                                        to bring back a piece of our heritage.
                                    </p>
                                    <p>
                                        Growing up, I remember the distinct aroma of fresh coconut oil being prepared at home—the
                                        kind extracted slowly, lovingly, and without shortcuts. It wasn't just an ingredient; it was a
                                        part of our lives. Over time, I watched this tradition fade, replaced by refined oils that
                                        prioritized shelf life over substance, quantity over quality.
                                    </p>
                                    <p>
                                        That's when I knew it was time to make a change.
                                    </p>
                                    <p>
                                        At Haronics, we are on a mission to reintroduce purity into everyday living—starting with
                                        something as essential as oil. We use the traditional wood-pressed method to ensure that
                                        every drop you use is as close to nature as possible.
                                    </p>
                                    <p>
                                        Thank you for trusting us and being part of our journey to bring real food back to the table.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 5: Mission and Vision */}
            <section
                ref={sectionRefs[4]}
                className={`mission-vision-section ${getAnimationClass(4)}`}
            >
                <div>
                    <div className="row ourMissionVission">
                        <div className="col-md-6">
                            <div className="mission-card flip-in">
                                <h2>Our Mission</h2>
                                <p>
                                    At Haronics Cold Pressed Oils, our mission is to revive India's traditional
                                    food wisdom by producing pure, chemical-free, and nutrient-rich oils
                                    through sustainable, cold-pressed methods.
                                </p>
                                <p>
                                    We are committed to offering natural alternatives that support holistic well-
                                    being, authentic taste, and ethical sourcing, ensuring our products nourish
                                    both people and the planet.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vision-card flip-in delay-2">
                                <h2>Our Vision</h2>
                                <p>
                                    We envision a healthier world where every household has access to unrefined,
                                    natural oils that are as close to nature as possible.
                                </p>
                                <p>
                                    Our goal is to be a trusted name in conscious living, inspiring communities to
                                    reconnect with their roots, choose clean nutrition, and embrace a lifestyle built
                                    on purity, tradition, and transparency.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="background-animation"></div>
            </section>
            {/* Section 5: award section */}
            <AwardSection />

            {/* Section 6: Cold Pressed vs Refined Oils */}
            {/* <section
                className={`comparison-section ${getAnimationClass(5)}`}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="fade-in">Cold Pressed Oils vs Refined Oils</h2>
                            <p className="subtitle fade-in delay-1">Know the Difference</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <div className="comparison-table slide-in-up">
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Feature</th>
                                                <th className="cold-pressed">Cold Pressed Oils (Haronics)</th>
                                                <th className="refined">Refined Oils</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="animate-row">
                                                <td>Extraction Method</td>
                                                <td>Pressed at low temperature using wooden churners (Ghani)</td>
                                                <td>High-heat chemical-based extraction</td>
                                            </tr>
                                            <tr className="animate-row">
                                                <td>Nutrient Retention</td>
                                                <td>Retains natural vitamins (E, K), antioxidants, and essential fatty acids</td>
                                                <td>Most nutrients lost due to high heat and refining agents</td>
                                            </tr>
                                            <tr className="animate-row">
                                                <td>Additives</td>
                                                <td>100% chemical-free, no preservatives or artificial agents</td>
                                                <td>Often contains solvents, deodorants, and stabilizers</td>
                                            </tr>
                                            <tr className="animate-row">
                                                <td>Taste & Aroma</td>
                                                <td>Natural flavor and aroma of the seed/nut retained</td>
                                                <td>Neutral or artificial taste; aroma is often masked</td>
                                            </tr>
                                            <tr className="animate-row">
                                                <td>Health Benefits</td>
                                                <td>Boosts immunity, heart health, and digestion</td>
                                                <td>May contain trans fats and residues harmful over time</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <div className="cta-button bounce-in">
                                <button className="btn btn-primary">Choose Haronics</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* Section 7: Why Choose Haronics */}
            <section
                ref={sectionRefs[6]}
                className={`why-choose-section ${getAnimationClass(6)}`}
            >
                <div className="row">
                    <div className="col-12 text-center">
                        <h2 className="fade-in">Why Choose Haronics Cold Pressed Oils?</h2>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-6">
                        <div className="benefits-list">
                            {[
                                {
                                    icon: "✅", title: "100% Natural & Chemical-Free",
                                    desc: "Our oils are completely free from chemicals, preservatives, and artificial additives."
                                },
                                {
                                    icon: "🏺", title: "Traditional Wood-Pressed Method",
                                    desc: "We follow the ancient wood-pressing technique that preserves essential nutrients."
                                },
                                {
                                    icon: "🌾", title: "Premium-Quality Raw Materials",
                                    desc: "Our oils begin with carefully selected, high-grade seeds and coconuts."
                                },

                            ].map((item, idx) => (
                                <div key={idx} className={`benefit-item slide-in-left delay-${idx}`}>
                                    <div className="benefit-icon">{item.icon}</div>
                                    <div className="benefit-content">
                                        <h3>{item.title}</h3>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="benefits-list">
                            {[
                                {
                                    icon: "❤️", title: "Multipurpose Wellness",
                                    desc: "Haronics oils aren't just for cooking—they're perfect for skin care, hair care, and more."
                                },
                                {
                                    icon: "🌿", title: "Sustainable & Responsible",
                                    desc: "We are deeply committed to eco-friendly practices and supporting local farmers."
                                },
                                {
                                    icon: "✅", title: "Transparency You Can Trust",
                                    desc: "From farm to bottle, we maintain complete transparency in our process."
                                }
                            ].map((item, idx) => (
                                <div key={idx} className={`benefit-item slide-in-right delay-${idx}`}>
                                    <div className="benefit-icon">{item.icon}</div>
                                    <div className="benefit-content">
                                        <h3>{item.title}</h3>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>

                <div className="floating-leaves">
                    {[...Array(8)].map((_, i) => (
                        <div key={i} className={`leaf leaf-${i + 1}`}></div>
                    ))}
                </div>
            </section>

            {/* Section 8: Oil Types and Uses */}
            <section
                ref={sectionRefs[7]}
                className={`oil-types-section ${getAnimationClass(7)}`}
            >
                <div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="fade-in">Haronics Cold Pressed Oils: Uses & Benefits</h2>
                            <p className="subtitle fade-in delay-1">
                                Extracted through a natural, chemical-free process using wooden churners
                            </p>
                        </div>
                    </div>
                    <div className="row mt-5">
                        {[
                            {
                                icon: "🥥",
                                title: "Cold Pressed Coconut Oil",
                                uses: ["Cooking: Ideal for sautéing, frying, and baking", "Hair Care: Deep conditioning and dandruff control", "Skin Care: Natural moisturizer and makeup remover", "Oil Pulling: For oral detox"],
                                benefits: ["Boosts metabolism and aids in weight management", "Rich in lauric acid — supports immunity", "Prevents protein loss in hair and improves scalp health", "Has antimicrobial, antifungal properties"]
                            },
                            {
                                icon: "🥜",
                                title: "Cold Pressed Groundnut Oil",
                                uses: ["Indian cooking: deep frying, tadka, and curries", "Baking and roasting", "Massage oil in Ayurveda"],
                                benefits: ["Contains resveratrol – supports heart health", "Monounsaturated fats help lower bad cholesterol", "Improves insulin sensitivity"]
                            },
                            {
                                icon: "🌱",
                                title: "Cold Pressed Sesame Oil",
                                uses: ["South Indian and Asian cuisine", "Oil pulling for oral care", "Abhyanga (Ayurvedic massage)"],
                                benefits: ["Rich in calcium and zinc – good for bones", "Balances Vata and Kapha doshas in Ayurveda", "Natural sunblock and anti-inflammatory properties"]
                            },
                            {
                                icon: "🌿",
                                title: "Cold Pressed Mustard Oil",
                                uses: ["Eastern and North Indian cuisine", "Hair oil and body massage", "Preserving traditional pickles"],
                                benefits: ["Boosts circulation and body warmth", "Antibacterial, antifungal – ideal for skin infections", "Improves appetite and digestion"]
                            }
                        ].map((oil, idx) => (
                            <div key={idx} className="col-md-6 col-lg-3 mb-4">
                                <div className={`oil-card flip-in delay-${idx}`}>
                                    <div className="oil-icon">{oil.icon}</div>
                                    <h3>{oil.title}</h3>
                                    <div className={`oil-details ${expandedSections[idx] ? 'expanded' : ''}`}>
                                        <div className="uses">
                                            <h4>Uses:</h4>
                                            <ul>
                                                {oil.uses.map((use, i) => (
                                                    <li key={i}>{use}</li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="benefits">
                                            <h4>Benefits:</h4>
                                            <ul>
                                                {oil.benefits.map((benefit, i) => (
                                                    <li key={i}>{benefit}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <button
                                        className="toggle-btn"
                                        onClick={() => toggleSection(idx)}
                                    >
                                        {expandedSections[idx] ? 'Show Less' : 'Show More'}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Section 9: Top Benefits */}
            <section
                ref={sectionRefs[8]}
                className={`top-benefits-section ${getAnimationClass(8)}`}
            >
                <div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="fade-in">Top Benefits of Cold Pressed Oils</h2>
                            <p className="subtitle fade-in delay-1">
                                Extracted at low temperatures without using heat or chemicals, preserving their natural nutrients, flavor, and aroma
                            </p>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-12">
                            <div className="benefits-grid">
                                {[
                                    {
                                        icon: "✅", title: "Nutrient-Rich and Unrefined",
                                        desc: "Retains essential fatty acids, vitamins, and antioxidants."
                                    },
                                    {
                                        icon: "❤️", title: "Heart-Healthy",
                                        desc: "Rich in monounsaturated and polyunsaturated fats."
                                    },
                                    {
                                        icon: "🛡️", title: "Boosts Immunity",
                                        desc: "Naturally contains antioxidants and phytochemicals that strengthen the immune system."
                                    },
                                    {
                                        icon: "🍽️", title: "Supports Digestive Health",
                                        desc: "Easily digestible and gentle on the stomach."
                                    },
                                    // {
                                    //     icon: "✨", title: "Promotes Healthy Skin & Hair",
                                    //     desc: "Acts as a natural moisturizer and nourisher for skin."
                                    // },
                                    {
                                        icon: "🧘", title: "Ideal for Ayurvedic & Holistic Use",
                                        desc: "Used in traditional practices like oil pulling and therapeutic applications."
                                    },
                                    {
                                        icon: "🌿", title: "Chemical-Free and Preservative-Free",
                                        desc: "No additives, artificial flavors, or refining agents."
                                    },
                                    {
                                        icon: "👨‍🍳", title: "Enhanced Taste & Aroma",
                                        desc: "Brings out the natural flavors of food."
                                    },
                                    // {
                                    //     icon: "♻️", title: "Eco-Friendly & Sustainable",
                                    //     desc: "Extracted using traditional wooden cold press methods."
                                    // },
                                    {
                                        icon: "🧠", title: "Supports Brain & Hormonal Health",
                                        desc: "Omega-3 and Omega-6 fatty acids help in brain function and hormonal balance."
                                    }
                                ].map((benefit, idx) => (
                                    <div
                                        key={idx}
                                        className={`benefit-box scale-in delay-${idx % 5}`}
                                        style={{ animationDelay: `${(idx % 5) * 0.2}s` }}
                                    >
                                        <div className="benefit-icon">{benefit.icon}</div>
                                        <h3>{benefit.title}</h3>
                                        <p>{benefit.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <OilComparison />
        </div>
    );
};

export default HaronicsProfile;